import { useState } from "react";

import { Button } from "@mui/material";

import { AddCompanyMemberModal } from "components/AddCompanyMemberModal";
import { useAuthContext } from "hooks";
import { userHasAdminRoleInCompany } from "utils";

interface Props {
  onSuccess?: () => void;
}

export function AddCompanyMemberAccountButton(props: Props) {
  const { onSuccess } = props;
  const { user } = useAuthContext();
  const [modalOpen, setModalOpen] = useState(false);

  if (user == null || !userHasAdminRoleInCompany(user)) {
    return null;
  }

  const adminRole = user.roles.find((r: Role) => r.type === "ADMINISTRATOR");
  if (!adminRole?.company?.id) {
    return null;
  }

  const handleOpenModal = () => {
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
  };

  const handleSuccess = () => {
    setModalOpen(false);
    onSuccess?.();
  };

  return (
    <>
      <Button variant="contained" size="small" onClick={handleOpenModal}>
        Add Team Members
      </Button>
      <AddCompanyMemberModal
        open={modalOpen}
        onClose={handleCloseModal}
        onSuccess={handleSuccess}
      />
    </>
  );
}
